import axios from 'axios';
import Cookie from 'js-cookie';

// API_URL from .env - same for client and server
const getBaseURL = () => {
  return process.env.API_URL;
};

export const axiosInstance = axios.create({
  baseURL: getBaseURL(),
  withCredentials: true
});

axiosInstance.interceptors.request.use(async config => {
  if (typeof window !== 'undefined') {
    const jwt = Cookie.get('jwt');

    if (jwt) {
      config.headers['X-Access-Token'] = jwt;
    }

    return config;
  }

  return config;
}, err => Promise.reject(err));

axiosInstance.interceptors.response.use(
  response => response,
  error => Promise.reject(error.response.data)
);
